<template>
    <div class="co-novo-documento-signatario-email-signatario">
        <v-combobox
            ref="emailSignatarioNovo"
            v-model="value.email"
            v-validate="'required|email'"
            :class="campoRequerido ? 'required-field email-signatario' : ''"
            :error-messages="errors.collect('E-mail')"
            :items="signatariosSugestoes.concat(sugestoes)"
            :no-data-text="noDataText"
            name="E-mail"
            label="E-mail"
            hide-details
            :placeholder="placeholder"
            outlined
            dense
            persistent-placeholder
            @blur="blur"
            @focus="focus"
            @keyup="checarInputParaExibirSugestaoEmail"
        >
            <template v-slot:prepend-inner>
                <div class="email-left">Email</div>
            </template>
        </v-combobox>
    </div>
</template>

<script>
export default {
    name: 'EmailSignatarioNovo',
    data() {
        return {
            sugestoes: [],
            sugestoesDominioLista: ['gmail.com', 'outlook.com', 'hotmail.com', 'live.com', 'uol.com.br', 'bol.com.br', 'yahoo.com', 'yahoo.com.br']
        }
    },
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        signatariosSugestoes: {
            type: Array,
        }
    },
    computed: {
        noDataText() {
            return `Não há ${this.$tc("pt_br.signatario", 2).toLowerCase()} cadastrados.`
        },
        placeholder() {
            return `E-mail do ${this.$tc("pt_br.signatario").toLowerCase()}`
        }
    },
    methods: {
        blur() {
            this.$refs.emailSignatarioNovo.blur();
        },
        checarInputParaExibirSugestaoEmail(e) {
            const valorInput = e.currentTarget.value

            if (!valorInput) {
                this.sugestoes = []
                return
            }

            if (valorInput.includes('@')) {
                this.montarSugestoesEmail(valorInput)
            } else {
                this.sugestoes = []
            }
        },
        focus(e) {
            this.$refs.emailSignatarioNovo.focus();
            this.sugestoes = []

            if (!!e.currentTarget.value) {
                this.checarInputParaExibirSugestaoEmail(e)
            }
        },
        montarSugestoesEmail(inputAtual) {
            this.sugestoes = []

            this.sugestoesDominioLista.forEach(sugestaoEmail => {
                const inputAtualSemDominio = inputAtual.replace(/@.*/, '@')
                if (this.signatariosSugestoes.includes(inputAtualSemDominio + sugestaoEmail)) return

                this.sugestoes.push(inputAtualSemDominio + sugestaoEmail)
            })
        },
        validarCampo() {
            return this.campoRequerido ? 'required' : ''
        }
    }
}
</script>

<style lang="stylus">
.co-novo-documento-signatario-email-signatario

    .email-left
        color var(--primary)
        padding-top 5px

    .v-text-field__slot
        input
            padding-left 28px
</style>